{
  "addDomain": "Add Domain",
  "usersEmailDomainAllowedLog": "Users with this email domain will be allowed to log in.",
  "domains": "Domains",
  "domainsListedHereAllowedLog": "Domains listed here are allowed to log in.",
  "domain": "Domain",
  "active": "Active",
  "deactivated": "Deactivated",
  "n911DispatcherAccess": "911 Dispatcher Access",
  "allVerified911DispatcherAccess": "All verified 911 Dispatcher Access users who have logged in using an allowed domain.",
  "allowed": "Allowed",
  "rejected": "Rejected",
  "allUsers": "All Users",
  "activeDomain": "Active Domain",
  "deactivateDomain": "Deactivate Domain",
  "deleteDomain": "Delete Domain",
  "noDomainsFound": "No domains found",
  "tryDifferentNameCheckTypos": "Try a different name or check for typos.",
  "noActiveDomainsYet": "No active domains yet",
  "addDomainControlWhoLog": "Add a domain to control who can log in.",
  "noDeactivatedDomains": "No deactivated domains",
  "domainsDeactivateAppearHere": "Domains you deactivate will appear here.",
  "noUsersMatchSearch": "No users match your search",
  "tryDifferentNameEmailAddress": "Try a different name or email address.",
  "noUsersYet": "No users yet",
  "leUsersAppearHereOnce": "LE users will appear here once they log in using an allowed domain.",
  "noRejectedAttempts": "No rejected attempts",
  "anyLoginAttemptsDomainsNot": "Any login attempts from domains not on your whitelist will appear here.",
  "noMatchYourSearch": "No match your search",
  "tryADifferentName": "Try a different name.",
  "deactivateTitle": "Deactivate <name/>?",
  "domainUsersBlocked": "{{count}} users with a @{{domain}} email address will not be able to log in to the web app until this domain is reactivated.",
  "userBlockedUntilReactivated": "{{name}} ({{email}}) will not be able to log in to the web app until this user is reactivated.",
  "typeToConfirm": "Type <name/> to confirm",
  "deleteTitle": "Delete <name/>?",
  "usersDeletedWarning": "{{title}} will be permanently removed and will lose all access to the web app. This cannot be undone.",
  "deleteDomainUsers_zero": "Deleting this domain will permanently remove all {{count}} user and revoke their access immediately.",
  "deleteDomainUsers_one": "Deleting this domain will permanently remove all {{count}} user and revoke their access immediately.",
  "deleteDomainUsers_other": "Deleting this domain will permanently remove all {{count}} users and revoke their access immediately.",
  "userDeletedWarning": "{{title}} ({{email}}) will be permanently removed and will lose all access to the web app. This cannot be undone.",
  "searchDomains": "Search domains",
  "lastLogin": "Last login",
  "haveBeenDeleted": "have been deleted.",
  "haveBeenDeactivated": "have been deactivated.",
  "haveBeenAdded": "have been added.",
  "haveBeenActivated": "have been activated.",
  "rejectedAttemptHaveBeenDeleted": "rejected attempt have been deleted.",
  "rejectedLogin": "Rejected Login",
  "deactivate": "Deactivate"
}
